
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Plus, CircleHelp } from 'lucide-react';
import { 
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogClose
} from "@/components/ui/dialog";

interface BlogAdminHeaderProps {
  onCreatePost: () => void;
}

export const BlogAdminHeader: React.FC<BlogAdminHeaderProps> = ({ onCreatePost }) => {
  const [helpOpen, setHelpOpen] = useState(false);
  
  const helpContent = {
    title: "Blog Management Help",
    description: "Manage your blog content efficiently",
    content: (
      <>
        <p>Welcome to the Blog Management area! Here you can:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Create new blog posts</li>
          <li>Edit existing content</li>
          <li>Publish or unpublish posts</li>
          <li>Delete or duplicate content</li>
          <li>Search and filter your posts</li>
        </ul>
        <p>Use the search functionality to quickly find specific posts in your collection.</p>
      </>
    )
  };
  
  return (
    <div className="flex justify-between items-center">
      <h1 className="text-3xl font-bold inline-flex items-center gap-2">
        Blog Management
        <CircleHelp
          className="h-5 w-5 text-primary cursor-pointer hover:text-primary/80 transition-colors"
          onClick={() => setHelpOpen(true)}
          strokeWidth={2}
        />
      </h1>
      <Button onClick={onCreatePost} className="flex items-center gap-2">
        <Plus size={16} />
        Create Post
      </Button>
      
      {/* Help Dialog */}
      <Dialog open={helpOpen} onOpenChange={setHelpOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>{helpContent.title}</DialogTitle>
            <DialogDescription>
              {helpContent.description}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            {helpContent.content}
          </div>
          <div className="flex justify-end">
            <DialogClose asChild>
              <Button variant="default" size="sm">Got it</Button>
            </DialogClose>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
